import { mixins, styled } from '@bob/library'

export const DropdownWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.backgroundPrimary};
  white-space: nowrap;
  ${mixins.padding(20)}
`

export const DropdownItemWrapper = styled.li`
  display: inline;
  padding: 10px;
`

export const MenuList = styled.ul`
  display: flex;
  gap: 32px;
  list-style-type: none;
  padding: 0;
  margin: 0;
`

export const MenuListItem = styled.li`
  display: flex;
  align-items: center;
`
